import React, { useRef, useState } from "react";
import { storage } from "../firebase/firebaseConfig";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { db, auth } from "../firebase/firebaseConfig";
import {
  addDoc,
  collection,
  doc,
  getDoc,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";

export default function FileUploadInput(props) {
  const { selesctedPreset, setFileDownLoadUrl, setIsOpen } =
    props;
  const currentUser = auth.currentUser;
  const [progresspercent, setProgresspercent] = useState(0);
  const [uploadedFile, setUploadedFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleSubmit = () => {
    if (!currentUser.uid) return;

    const file = fileInputRef.current.files[0];

    if (!file) return alert("Attach the file then upload");
    if (!selesctedPreset) return alert("Please select the preset");

    const storageRef = ref(storage, `files/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgresspercent(progress);
      },
      (error) => {
        alert(error);
      },

      async () => {
        const docRef = await doc(db, "users", currentUser.uid);

        const docSnap = await getDoc(docRef);
        const userData = docSnap.data();

        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setFileDownLoadUrl(downloadURL);
          setIsOpen(true);
          addDoc(collection(db, "users"), {
            ...userData,
            originalFile: downloadURL,
            presetName: selesctedPreset,
            preset: selesctedPreset,
            status: false,
            userId: currentUser.uid,
            processedFile: null,
            email_address: currentUser.email,
          }).then((data) => {
            console.log("Successfully added Data to Firestore", data);
            //  console.log(downloadURL)
            //    setDoc(doc(db, "users", currentUser.uid), {
            //     ...userData,
            //     preset: selesctedPreset,
            //     status: false,
            //     originalFile: downloadURL
            //   });
            // }).then(async(data) => {
            const functions = getFunctions();
            try {
              const sendEmail = httpsCallable(functions, "sendEmail");

              console.log("userData", userData, docSnap.data());
              sendEmail({
                userId: currentUser.uid,
                downloadURL: downloadURL,
                name: userData.firstName + " " + userData.lastName,
              }).then((result) => {
                // Read result of the Cloud Function.
                /** @type {any} */
                console.log(result);
              });
            } catch (error) {
              console.log(error);
            }
          });
        });
      }
    );
  };

  return (
    <>
      <form className="cursor-pointer">
        <div className="flex w-64 items-center justify-center gap-3 rounded-xl border border-dashed border-white/15 bg-navy-700 px-4 py-3 text-base transition-colors hover:border-accent/60">
          <label
            htmlFor="file-upload"
            className="flex cursor-pointer items-center gap-3 text-white/80 transition-colors hover:text-accent"
          >
            <span className="break-all">
              {uploadedFile ? uploadedFile : "Select a File"}
            </span>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
              strokeWidth={1.5}
              className="h-6 w-6 shrink-0"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
              />
            </svg>
          </label>

          <input
            ref={fileInputRef}
            id="file-upload"
            name="file-upload"
            type="file"
            onChange={(e) => {
              const file = e.target.files[0];
              if (file.size > 100 * 1024 * 1024)
                return alert("The size of the file is too large");

              if (file.type !== "audio/mpeg" && file.type !== "audio/wav")
                return alert("Only MP3 and Wav audio files can be uploaded");
              setUploadedFile(file.name);
            }}
            className="sr-only"
          />
        </div>
      </form>
      <button
        onClick={handleSubmit}
        type="submit"
        className="rounded-xl border border-transparent bg-accent px-7 py-2.5 text-base font-bold capitalize text-navy-900 shadow-sm transition-colors duration-200 hover:bg-accent-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-navy-900"
      >
        {progresspercent === 0 || progresspercent === 100
          ? "upload"
          : `${progresspercent}%`}
      </button>
    </>
  );
}
